import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/integralmaterialanalysisresultserv'

export default {
  state: {
    state_IntegralMaterialAnalysisResult_GetPageResult: null,
    state_IntegralMaterialAnalysisResult_GetDetailResult: null,
    state_IntegralMaterialAnalysisResult_GetClientPageResult: null,
    state_IntegralMaterialAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_INTEGRALMATERIALANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_IntegralMaterialAnalysisResult_GetPageResult = rst;
    },
    SET_INTEGRALMATERIALANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_IntegralMaterialAnalysisResult_GetDetailResult = rst;
    },
    SET_INTEGRALMATERIALANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_IntegralMaterialAnalysisResult_GetClientPageResult = rst;
    },
    SET_INTEGRALMATERIALANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_IntegralMaterialAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    IntegralMaterialAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    IntegralMaterialAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    IntegralMaterialAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    IntegralMaterialAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_INTEGRALMATERIALANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_IntegralMaterialAnalysisResult_GetPageResult: state => {
      return state.state_IntegralMaterialAnalysisResult_GetPageResult;
    },
    get_IntegralMaterialAnalysisResult_GetDetailResult: state => {
      return state.state_IntegralMaterialAnalysisResult_GetDetailResult;
    },
    get_IntegralMaterialAnalysisResult_GetClientPageResult: state => {
      return state.state_IntegralMaterialAnalysisResult_GetClientPageResult;
    },
    get_IntegralMaterialAnalysisResult_ExportExcelResult: state => {
      return state.state_IntegralMaterialAnalysisResult_ExportExcelResult;
    },
  }
}